import { render, staticRenderFns } from "./SpotlightIcon.vue?vue&type=template&id=1598dfb6&"
import script from "./SpotlightIcon.vue?vue&type=script&lang=js&"
export * from "./SpotlightIcon.vue?vue&type=script&lang=js&"
import style0 from "./SpotlightIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports